// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/interstate-2);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;
/* @import url('https://fonts.cdnfonts.com/css/metropolis-2'); */
/* @import url('https://www.losttype.com/font/?name=veneraColors'); */

.example {
  overflow-y: scroll;
  bottom: 50px;
  width: 80%;
  border: 1px solid #e6e6e6;
  border-top: none;
  top: 8em;
  /* box-shadow: rgb(100 100 111 / 20%) 0px 7px 5px 0px; */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.example::-webkit-scrollbar {
  display: none;
}

.inputLabel {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  color: #9b9b9b;
}
.inputLabelText {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  width: 100%;
}

.exampleZones {
  overflow-y: scroll;
  width: 20%;
  height: 83vh;
  /* border: 1px solid #e6e6e6;
  border-top: none; */
  background: white;
  border-radius: 0 5px 5px 0;
  border-color: lightgrey;
  /* box-shadow: 
  /* box-shadow: rgb(100 100 111 / 20%) 0px 7px 5px 0px; */
}

.inputBox {
  background: #f8f8f8;
  border: 0.5px solid #dddddd;
  box-sizing: border-box;
  border-radius: 5px;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.exampleZones::-webkit-scrollbar {
  display: none;
}

.projecTUser {
  overflow-y: scroll;
  position: absolute;
  bottom: 0em;
  top: 4em;
  /* box-shadow: rgb(100 100 111 / 20%) 0px 7px 5px 0px; */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.projecTUser::-webkit-scrollbar {
  display: none;
}

canvas {
  height: 100% !important;
}
.backgroundImg {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

::placeholder {
  color: #b3b3b3;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #b3b3b3;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #b3b3b3;
}

.hideScroll::-webkit-scrollbar {
  display: none;
}
.showScroll::-webkit-scrollbar {
  width: 3px;
  height: 5px;
  background-color: #e8e8e8; /* or add it to the track */
}
.showScroll::-webkit-scrollbar-thumb {
  background: #a8a8a8;
}

.userInfo {
  margin: auto;
  margin-top: 1rem;
  color: white;
  font-weight: 700;
}

.x {
  font-weight: 700;
}

.y {
  border: 1px solid gray;
  padding: 0.3em 1em;
  margin: 8% 0;
}

@media screen and (max-width: 800px) {
  .textSize {
    font-size: 12px;
    font-weight: 700;
    margin-top: 6px;
  }
  .dashboard {
    position: absolute;
    top: 15%;
    left: 2%;
    color: #1e3651;
    /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 5px 0px; */
  }
}

.dashboard {
  position: absolute;
  top: 15%;
  left: 2%;
  color: #1e3651;
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 5px 0px; */
}

.insightBar {
  position: fixed;
  z-index: 99999;
  width: 84%;
  left: 15%;
  bottom: 0.5em;
}

.tbl {
  margin-top: 0;
}

@media screen and (min-width: 1000px) {
  .tbl {
    margin-top: -10vh;
  }
}
.userInfo {
  margin: auto;
  margin-top: 1em;
  margin-bottom: 1em;
  color: white;
  font-weight: 700;
}

.x {
  font-weight: 700;
  color: #1e3651;
}

.logoutBtn {
  margin: 1em 0;
  border-radius: 5px;
  box-shadow: rgb(100 100 111 / 20%) 0px -1px 2px 1px;
  font-size: 0.8em;
  color: #b3b3b3;
}

.searchBar {
  position: absolute;
  top: 15%;
  right: 2%;
  border: 1px solid #e6e6e6;
}

.searchInput {
  border: transparent;
  outline: none;
  background: transparent;
  font-size: 1em;
  padding: 0px 4em 0.4em 1em;
  color: #b3b3b3;
  width: 300px;
}

.searchImage {
  margin-top: 6px;
  height: 1.2em;
  padding-right: 10px;
}

.imgSize {
  width: 90%;
  /* height: 0%; */
  text-align: center;
  align-items: center;
  /* margin: auto; */
  /* marginTop: 20px; */
  /* margin-bottom: 2em; */
}

@media screen and (min-width: 1400px) {
  .imgSize {
    width: 95%;
    /* height: 0%; */
    text-align: center;
    align-items: center;
    /* margin: auto; */
    /* marginTop: 20px; */
    /* margin-bottom: 4em; */
  }

  .logout {
    bottom: 2vh;
    /* border: 1px solid #E6E6E6; */
    text-align: center;
    box-shadow: rgb(100 100 111 / 20%) 1px 0px 2px 1px;
    border-radius: 5px;
    margin: auto;
    width: 80%;
    position: relative;
    /* bottom: -2em; */
  }
}

.logout {
  /* position: absolute; */
  border: 1px solid #e6e6e6;
  margin: auto;
  text-align: center;
  width: 80%;
  position: relative;
  /* bottom: -2em; */
}

.sideMenu {
  background: #ffffff;
  box-shadow: 0px 4px 5px 3px rgba(0, 0, 0, 0.05);
  border-radius: 0px;
  width: 14%;
}

  text-overflow: ellipsis;
select {
  color: white;
  font-weight: 700;
}
select option {
  color: black;
}
/* select option :focus :active {
  background-color: #005072 !important;
  color: white;
} */

select option:hover {
  box-shadow: 0 0 10px 100px #1882a8 inset;
}

/* select option:first-child{
  color: white;
} */
.pagenumbers {
  display: flex;
  list-style: none;
  border: 1px solid grey;
  display: inline-flex;
  /* margin-left: 74%; */
  /* right: 0px; */
  /* height: 20%; */
  /* width: 250px; */
  /* right: 4.5%; */
  border-radius: 5px;
  /* bottom: -3%; */
  max-width: 250px;
  float: right;
  /* position: absolute; */
}

.pagenumbersDashboard {
  display: flex;
  list-style: none;
  border: 1px solid grey;
  display: inline-flex;
  /* margin-left: 74%; */
  right: 0px;
  /* height: 20%; */
  /* width: 250px; */
  right: 1%;
  border-radius: 12px;
  /* bottom: -3%; */
  max-width: 250px;
  position: absolute;
}

.pagenumbersDashboard li {
  padding: 1px;
  width: 50px;
  /* max-width: 50px; */
  /* margin-top: 4px; */
  margin: 2%;
  cursor: pointer;
  color: #666666;
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
}

.pagenumbersDashboard li.active {
  background-color: #0761a6;
  color: white;
  width: 25%;
  max-width: 30px;
  /* height: 34%;*/
}

.pagenumbersDashboard li button {
  background-color: transparent;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  margin-top: -5px;
  width: 20px;
  max-width: 20px;
}
.pagenumbersDashboard li button:hover {
  background-color: white;
  color: black;
}

.pagenumbersDashboard li button:focus {
  outline: none;
}

.pagenumbers li {
  /* padding: 0.1em; */
  width: 30px;
  /* max-width: 50px; */
  /* margin-top: 4px; */
  /* margin: 1%; */
  cursor: pointer;
  color: #666666;
  /* font-size: 0.75rem; */
  /* font-weight: 400; */
  text-align: center;
}

.pagenumbers li.active {
  background-color: #005072;
  color: white;
  width: 25%;
  max-width: 30px;
  /* height: 34%;*/
}

.pagenumbers li button {
  background-color: transparent;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  margin-top: -5px;
  width: 20px;
  max-width: 20px;
}
.pagenumbers li button:hover {
  background-color: white;
  color: black;
}

.pagenumbers li button:focus {
  outline: none;
}

.button-rotate {
  transform: rotate(180deg);
  margin-top: 6px;
  width: 60%;
}

.button-anti {
  margin-top: 6px;
  width: 60%;
}

spacing {
  margin-left: -9px;
  margin-top: -21px;
}
.spacing_device {
  margin-left: 5px;
  margin-top: -23px;
}
.marginIcon {
  margin-left: -53px;
}
.marginIconDevice {
  margin-left: -49px;
}

.marginDeviceproject {
  margin-left: -48px;
  /* text-align: center; */
  margin-top: 7px;
}

.error_message {
  max-width: 20%;
  margin-left: 40%;
  margin-top: 1%;
}

.new_notification {
  margin-top: 40%;
  margin-left: 41%;
  width: 20%;
}

[contenteditable='true']:empty:before {
  content: attr(placeholder);
  color: gray;
}
/* found this online --- it prevents the user from being able to make a (visible) newline */
[contenteditable='true'] br {
  display: none;
}

/* #span1 {
  -moz-appearance: textfield;
  -webkit-appearance: textfield;
  background-color: white;
  background-color: -moz-field;
  border: 0.5px solid #abadb3;
  border-bottom: 0.5px solid #e3e9ef;
  border-right: 0.5px solid #e3e9ef;
  font: -moz-field;
  font: -webkit-small-control;
  padding-left: 5px;
  white-space: nowrap;
  padding: 1.7px;
} */

.user_colour {
  color: #9b9b9b;
}
.width_stat {
  width: 12.5%;
}

.dash_main {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  left: 13%;
  right: 13%;
}

.firm_main {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  left: 13%;
  height: 94vh;
  right: 13%;
  border-radius: 6px;
}

.boxsize {
  border: 0.5px solid #c0c0c0;
  box-sizing: border-box;
  border-radius: 4px;
}

.nav_org {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  left: 13%;
  right: 13%;
  width: 81%;
  border-radius: 6px;
  height: 94vh;
}

/* .width_org {
  width: 100%;
} */

.nav_user {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  left: 13%;
  right: 13%;
  width: 81%;
  border-radius: 6px;
  height: 94vh;
}

.nav_devices {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  left: 13%;
  right: 13%;
  /* width: 81%; */
  border-radius: 6px;
  height: 94vh;
}

.nav_login {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  left: 14%;
  right: 14%;
  width: 81%;
  border-radius: 6px;
  height: 94vh;
}

@media only screen and (min-width: 600px) {
  .mobile_login {
    width: 189% !important;
    margin-left: -39% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;AACnB,gEAAgE;AAEhE,qEAAqE;;AAErE;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,QAAQ;EACR,wDAAwD;AAC1D;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ;qBACmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB;0DACwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,wDAAwD;AAC1D;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,UAAU,EAAE,YAAY;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB,EAAE,2BAA2B;AACxD;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,cAAc;IACd,0DAA0D;EAC5D;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,cAAc;EACd,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mDAAmD;EACnD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;IAClB,kDAAkD;IAClD,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;AACZ;;EAEE,uBAAuB;AACzB;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;;;GAGG;;AAEH;EACE,wCAAwC;AAC1C;;AAEA;;GAEG;AACH;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA,2FAA2F;AAC3F;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,SAAS;EACT,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,2CAA2C;EAC3C,SAAS;EACT,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,SAAS;EACT,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;AACF","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n/* @import url('https://fonts.cdnfonts.com/css/metropolis-2'); */\n@import url('https://fonts.cdnfonts.com/css/interstate-2');\n/* @import url('https://www.losttype.com/font/?name=veneraColors'); */\n\n.example {\n  overflow-y: scroll;\n  bottom: 50px;\n  width: 80%;\n  border: 1px solid #e6e6e6;\n  border-top: none;\n  top: 8em;\n  /* box-shadow: rgb(100 100 111 / 20%) 0px 7px 5px 0px; */\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.example::-webkit-scrollbar {\n  display: none;\n}\n\n.inputLabel {\n  font-family: Open Sans;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  color: #9b9b9b;\n}\n.inputLabelText {\n  background: #ffffff;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 5px;\n  width: 100%;\n}\n\n.exampleZones {\n  overflow-y: scroll;\n  width: 20%;\n  height: 83vh;\n  /* border: 1px solid #e6e6e6;\n  border-top: none; */\n  background: white;\n  border-radius: 0 5px 5px 0;\n  border-color: lightgrey;\n  /* box-shadow: \n  /* box-shadow: rgb(100 100 111 / 20%) 0px 7px 5px 0px; */\n}\n\n.inputBox {\n  background: #f8f8f8;\n  border: 0.5px solid #dddddd;\n  box-sizing: border-box;\n  border-radius: 5px;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.exampleZones::-webkit-scrollbar {\n  display: none;\n}\n\n.projecTUser {\n  overflow-y: scroll;\n  position: absolute;\n  bottom: 0em;\n  top: 4em;\n  /* box-shadow: rgb(100 100 111 / 20%) 0px 7px 5px 0px; */\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.projecTUser::-webkit-scrollbar {\n  display: none;\n}\n\ncanvas {\n  height: 100% !important;\n}\n.backgroundImg {\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n::placeholder {\n  color: #b3b3b3;\n  opacity: 1; /* Firefox */\n}\n\n:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #b3b3b3;\n}\n\n::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #b3b3b3;\n}\n\n.hideScroll::-webkit-scrollbar {\n  display: none;\n}\n.showScroll::-webkit-scrollbar {\n  width: 3px;\n  height: 5px;\n  background-color: #e8e8e8; /* or add it to the track */\n}\n.showScroll::-webkit-scrollbar-thumb {\n  background: #a8a8a8;\n}\n\n.userInfo {\n  margin: auto;\n  margin-top: 1rem;\n  color: white;\n  font-weight: 700;\n}\n\n.x {\n  font-weight: 700;\n}\n\n.y {\n  border: 1px solid gray;\n  padding: 0.3em 1em;\n  margin: 8% 0;\n}\n\n@media screen and (max-width: 800px) {\n  .textSize {\n    font-size: 12px;\n    font-weight: 700;\n    margin-top: 6px;\n  }\n  .dashboard {\n    position: absolute;\n    top: 15%;\n    left: 2%;\n    color: #1e3651;\n    /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 5px 0px; */\n  }\n}\n\n.dashboard {\n  position: absolute;\n  top: 15%;\n  left: 2%;\n  color: #1e3651;\n  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 5px 0px; */\n}\n\n.insightBar {\n  position: fixed;\n  z-index: 99999;\n  width: 84%;\n  left: 15%;\n  bottom: 0.5em;\n}\n\n.tbl {\n  margin-top: 0;\n}\n\n@media screen and (min-width: 1000px) {\n  .tbl {\n    margin-top: -10vh;\n  }\n}\n.userInfo {\n  margin: auto;\n  margin-top: 1em;\n  margin-bottom: 1em;\n  color: white;\n  font-weight: 700;\n}\n\n.x {\n  font-weight: 700;\n  color: #1e3651;\n}\n\n.logoutBtn {\n  margin: 1em 0;\n  border-radius: 5px;\n  box-shadow: rgb(100 100 111 / 20%) 0px -1px 2px 1px;\n  font-size: 0.8em;\n  color: #b3b3b3;\n}\n\n.searchBar {\n  position: absolute;\n  top: 15%;\n  right: 2%;\n  border: 1px solid #e6e6e6;\n}\n\n.searchInput {\n  border: transparent;\n  outline: none;\n  background: transparent;\n  font-size: 1em;\n  padding: 0px 4em 0.4em 1em;\n  color: #b3b3b3;\n  width: 300px;\n}\n\n.searchImage {\n  margin-top: 6px;\n  height: 1.2em;\n  padding-right: 10px;\n}\n\n.imgSize {\n  width: 90%;\n  /* height: 0%; */\n  text-align: center;\n  align-items: center;\n  /* margin: auto; */\n  /* marginTop: 20px; */\n  /* margin-bottom: 2em; */\n}\n\n@media screen and (min-width: 1400px) {\n  .imgSize {\n    width: 95%;\n    /* height: 0%; */\n    text-align: center;\n    align-items: center;\n    /* margin: auto; */\n    /* marginTop: 20px; */\n    /* margin-bottom: 4em; */\n  }\n\n  .logout {\n    bottom: 2vh;\n    /* border: 1px solid #E6E6E6; */\n    text-align: center;\n    box-shadow: rgb(100 100 111 / 20%) 1px 0px 2px 1px;\n    border-radius: 5px;\n    margin: auto;\n    width: 80%;\n    position: relative;\n    /* bottom: -2em; */\n  }\n}\n\n.logout {\n  /* position: absolute; */\n  border: 1px solid #e6e6e6;\n  margin: auto;\n  text-align: center;\n  width: 80%;\n  position: relative;\n  /* bottom: -2em; */\n}\n\n.sideMenu {\n  background: #ffffff;\n  box-shadow: 0px 4px 5px 3px rgba(0, 0, 0, 0.05);\n  border-radius: 0px;\n  width: 14%;\n}\n\n  text-overflow: ellipsis;\nselect {\n  color: white;\n  font-weight: 700;\n}\nselect option {\n  color: black;\n}\n/* select option :focus :active {\n  background-color: #005072 !important;\n  color: white;\n} */\n\nselect option:hover {\n  box-shadow: 0 0 10px 100px #1882a8 inset;\n}\n\n/* select option:first-child{\n  color: white;\n} */\n.pagenumbers {\n  display: flex;\n  list-style: none;\n  border: 1px solid grey;\n  display: inline-flex;\n  /* margin-left: 74%; */\n  /* right: 0px; */\n  /* height: 20%; */\n  /* width: 250px; */\n  /* right: 4.5%; */\n  border-radius: 5px;\n  /* bottom: -3%; */\n  max-width: 250px;\n  float: right;\n  /* position: absolute; */\n}\n\n.pagenumbersDashboard {\n  display: flex;\n  list-style: none;\n  border: 1px solid grey;\n  display: inline-flex;\n  /* margin-left: 74%; */\n  right: 0px;\n  /* height: 20%; */\n  /* width: 250px; */\n  right: 1%;\n  border-radius: 12px;\n  /* bottom: -3%; */\n  max-width: 250px;\n  position: absolute;\n}\n\n.pagenumbersDashboard li {\n  padding: 1px;\n  width: 50px;\n  /* max-width: 50px; */\n  /* margin-top: 4px; */\n  margin: 2%;\n  cursor: pointer;\n  color: #666666;\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-align: center;\n}\n\n.pagenumbersDashboard li.active {\n  background-color: #0761a6;\n  color: white;\n  width: 25%;\n  max-width: 30px;\n  /* height: 34%;*/\n}\n\n.pagenumbersDashboard li button {\n  background-color: transparent;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  margin-top: -5px;\n  width: 20px;\n  max-width: 20px;\n}\n.pagenumbersDashboard li button:hover {\n  background-color: white;\n  color: black;\n}\n\n.pagenumbersDashboard li button:focus {\n  outline: none;\n}\n\n.pagenumbers li {\n  /* padding: 0.1em; */\n  width: 30px;\n  /* max-width: 50px; */\n  /* margin-top: 4px; */\n  /* margin: 1%; */\n  cursor: pointer;\n  color: #666666;\n  /* font-size: 0.75rem; */\n  /* font-weight: 400; */\n  text-align: center;\n}\n\n.pagenumbers li.active {\n  background-color: #005072;\n  color: white;\n  width: 25%;\n  max-width: 30px;\n  /* height: 34%;*/\n}\n\n.pagenumbers li button {\n  background-color: transparent;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  margin-top: -5px;\n  width: 20px;\n  max-width: 20px;\n}\n.pagenumbers li button:hover {\n  background-color: white;\n  color: black;\n}\n\n.pagenumbers li button:focus {\n  outline: none;\n}\n\n.button-rotate {\n  transform: rotate(180deg);\n  margin-top: 6px;\n  width: 60%;\n}\n\n.button-anti {\n  margin-top: 6px;\n  width: 60%;\n}\n\nspacing {\n  margin-left: -9px;\n  margin-top: -21px;\n}\n.spacing_device {\n  margin-left: 5px;\n  margin-top: -23px;\n}\n.marginIcon {\n  margin-left: -53px;\n}\n.marginIconDevice {\n  margin-left: -49px;\n}\n\n.marginDeviceproject {\n  margin-left: -48px;\n  /* text-align: center; */\n  margin-top: 7px;\n}\n\n.error_message {\n  max-width: 20%;\n  margin-left: 40%;\n  margin-top: 1%;\n}\n\n.new_notification {\n  margin-top: 40%;\n  margin-left: 41%;\n  width: 20%;\n}\n\n[contenteditable='true']:empty:before {\n  content: attr(placeholder);\n  color: gray;\n}\n/* found this online --- it prevents the user from being able to make a (visible) newline */\n[contenteditable='true'] br {\n  display: none;\n}\n\n/* #span1 {\n  -moz-appearance: textfield;\n  -webkit-appearance: textfield;\n  background-color: white;\n  background-color: -moz-field;\n  border: 0.5px solid #abadb3;\n  border-bottom: 0.5px solid #e3e9ef;\n  border-right: 0.5px solid #e3e9ef;\n  font: -moz-field;\n  font: -webkit-small-control;\n  padding-left: 5px;\n  white-space: nowrap;\n  padding: 1.7px;\n} */\n\n.user_colour {\n  color: #9b9b9b;\n}\n.width_stat {\n  width: 12.5%;\n}\n\n.dash_main {\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 6px;\n  left: 13%;\n  right: 13%;\n}\n\n.firm_main {\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 6px;\n  left: 13%;\n  height: 94vh;\n  right: 13%;\n  border-radius: 6px;\n}\n\n.boxsize {\n  border: 0.5px solid #c0c0c0;\n  box-sizing: border-box;\n  border-radius: 4px;\n}\n\n.nav_org {\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  left: 13%;\n  right: 13%;\n  width: 81%;\n  border-radius: 6px;\n  height: 94vh;\n}\n\n/* .width_org {\n  width: 100%;\n} */\n\n.nav_user {\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  left: 13%;\n  right: 13%;\n  width: 81%;\n  border-radius: 6px;\n  height: 94vh;\n}\n\n.nav_devices {\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  left: 13%;\n  right: 13%;\n  /* width: 81%; */\n  border-radius: 6px;\n  height: 94vh;\n}\n\n.nav_login {\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  left: 14%;\n  right: 14%;\n  width: 81%;\n  border-radius: 6px;\n  height: 94vh;\n}\n\n@media only screen and (min-width: 600px) {\n  .mobile_login {\n    width: 189% !important;\n    margin-left: -39% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
